/**
 * ============================================================================
 * 🌐 Tactical Application Constants & Map Configurations
 * ============================================================================
 */

export const MAP_CONFIG = {
  DEFAULT_CENTER: [13.7367, 100.5231], // Bangkok
  DEFAULT_ZOOM: 6,
  MIN_ZOOM: 2,
  MAX_ZOOM: 20,
  TILES: {
    dark: {
      id: 'dark',
      name: 'Tactical Dark (ค่าเริ่มต้น)',
      icon: '🌑',
      url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
      attribution: '&copy; CartoDB',
      maxZoom: 19,
      subdomains: 'abcd'
    },
    google_sat: {
      id: 'google_sat',
      name: 'Google Satellite (Pure)',
      icon: '🛰️',
      url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
      attribution: '&copy; Google Maps',
      maxZoom: 20
    },
    google_hybrid: {
      id: 'google_hybrid',
      name: 'Google Satellite (Hybrid)',
      icon: '🌍',
      url: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
      attribution: '&copy; Google Maps',
      maxZoom: 20
    },
    satellite_esri: {
      id: 'satellite_esri',
      name: 'ESRI World Imagery (HD)',
      icon: '🛸',
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      attribution: '&copy; Esri',
      maxZoom: 18
    },
    osm_standard: {
      id: 'osm_standard',
      name: 'OpenStreetMap (Standard)',
      icon: '🗺️',
      url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 19
    },
    shaded_relief: {
      id: 'shaded_relief',
      name: 'ESRI Shaded Relief (Terrain)',
      icon: '🏔️',
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}',
      attribution: '&copy; Esri',
      maxZoom: 13
    },
    light: {
      id: 'light',
      name: 'Clean Light (Day Mode)',
      icon: '☀️',
      url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
      attribution: '&copy; CartoDB',
      maxZoom: 19,
      subdomains: 'abcd'
    }
  }
};

export const FLIGHT_PHASE_COLORS = {
  CLIMBING: '#10b981',
  CRUISE: '#38bdf8',
  DESCENDING: '#f59e0b',
  GROUND: '#94a3b8'
};

export const EMERGENCY_SQUAWKS = {
  '7700': { label: 'General Emergency', color: '#ef4444', icon: '🚨' },
  '7600': { label: 'Radio Failure', color: '#f59e0b', icon: '📻' },
  '7500': { label: 'Unlawful Interference', color: '#dc2626', icon: '⚠️' }
};

export const POLLING_INTERVAL_MS = 1000;

export const PLANE_ICON = {
  SIZE: 36,
  ANCHOR: 18
};

export const HOVER_TOOLTIP = {
  OFFSET_X: 18,
  OFFSET_Y: -25,
  ESTIMATED_WIDTH: 150,
  FLIP_LEFT_OFFSET: 160,
  TOP_EDGE_MARGIN: 10,
  FLIP_DOWN_OFFSET: 20,
  MIN_ZOOM_VISIBLE: 7
};
